module.exports = __webpack_public_path__ + "img/back.99768428.jpg";